import { float } from './float'

function decimal(unknown: unknown, fractionDigits = 2): string {
  return `${float(unknown, fractionDigits)}`
}

export { decimal }
